import React from "react";
import NumberFormat from 'react-number-format';
import { formatNumberOrReturnUndefined } from "@icarius-utils/format";



const CustomNumberFormat = (props) => {

    const {
        inputRef,
        onChange,
        decimals,
        prefix,
        suffix,
        format,
        fixedDecimalScale,
        ...other
    } = props;

    // Obtener los separadores de miles y decimales correctos según el idioma del navegador/usuario
    const n = formatNumberOrReturnUndefined(11111.1, 2);
    const decimalSeparator = n ? n.substring(n.length - 3, n.length - 2) : ',';
    const thousandSeparator = n ? n.substring(2, 3) : '.';

    return (
        <NumberFormat
            {...other}
            getInputRef={inputRef}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    },
                });
            }}
            thousandSeparator={format ? false : thousandSeparator}
            decimalSeparator={format ? false : decimalSeparator}
            isNumericString={!format}
            fixedDecimalScale={fixedDecimalScale !== undefined ? fixedDecimalScale : !format}
            decimalScale={decimals === 'auto' ? undefined : (decimals || 0)}
            prefix={prefix}
            suffix={suffix}
            format={format}
        />
    );
}

export default CustomNumberFormat;